<template>
    <div id="page-selects">
      <v-container fluid fill-height class="grey lighten-5">
        <v-card style="border-radius: 10px;" class="mx-3 mt-3" flat max-height="100%" max-width="100%" width="2000">
          <v-card-title>
            <v-row no-gutters class="mt-5">
              <v-col cols="3" sm="3" md="3">
                <span class="font-weight-bold"><h3 style="color: #003057;" >{{$t('WpLabRequest.LabResultReport')}}</h3></span>
              </v-col>
              <v-col cols="6" sm="6" md="6"></v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <!-- ส่วนของปุ่ม -->
          <v-card  flat  class="ml-6 mb-3 pr-2" height="100%">
            <v-row dense flat>
              <v-col cols="12" xl="3" sm="3" md="3" lg="3">
                <v-dialog ref="dialogReceivedDateFromTo" v-model="dialog.dialogReceivedDateFromTo"
                  :return-value.sync="criteria.ReceivedDateFromTo" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      height="40"
                      color="#003057"
                      class="mr-1 text-truncate"
                      :style="{ 
                        fontSize: $vuetify.breakpoint.mdAndDown ? '10px' : '12px'
                      }"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="#FFF" small class="mr-1">mdi-calendar</v-icon>
                      {{$t('WpLabRequest.receivedDate')}} {{ dateRangeText }}
                    </v-btn>
                  </template>
                  <v-date-picker v-model="criteria.ReceivedDateFromTo" :selected-items-text="selectDate" range scrollable @keydown.enter="retrieveLabResultReport">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog.dialogReceivedDateFromTo = false">Cancel</v-btn>
                    <v-btn text color="primary"
                      @click="$refs.dialogReceivedDateFromTo.save(criteria.ReceivedDateFromTo)">Ok</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2">
                <div class="ml-0">
                  <v-text-field 
                  class="text-center"
                  dense
                  outlined 
                  color="#003057"
                  height="30px" 
                  width="198"
                  hide-details 
                  :label="$t('WpLabRequest.patientName')" 
                  @keydown.enter="retrieveLabResultReport"
                  v-model="searchName">
                </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2">
                <v-text-field 
                  outlined 
                  dense 
                  color="#003057"
                  height="30px" 
                  width="195.75px"
                  hide-details 
                  :label="$t('WpLabRequest.HN')" 
                  @keydown.enter="retrieveLabResultReport"
                  v-model="find_hn">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2">
                <v-text-field 
                  outlined 
                  dense 
                  color="#003057"
                  height="30px" 
                  width="195.75px"
                  hide-details 
                  :label="$t('WpLabRequest.labNumber')" 
                  @keydown.enter="retrieveLabResultReport"
                  v-model="order_id">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="2" md="2" lg="2">
                <v-btn  
                    color="#1976D2"
                    height="40px" 
                    width="100%"
                    :style="{ 
                      'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                      'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                    }"
                    @click="retrieveLabResultReport(appName)"
                  >
                    <v-icon color="#FFF" :small="$vuetify.breakpoint.mdAndDown" class="mr-1">mdi-magnify</v-icon>
                    {{$t('WpLabRequest.searchData')}}
                  </v-btn>
              </v-col>
              <v-col cols="12" sm="1" md="1" lg="1">
                <v-btn  
                  color="success"
                  height="40px" 
                  width="100%"
                  :disabled="vDataTable.selected.length === 0"
                  :style="{ 
                    'font-size': $vuetify.breakpoint.mdAndDown ? '8px' : '12px',
                    'padding': $vuetify.breakpoint.mdAndDown ? '0 4px' : '' 
                  }"
                  @click="approveSelectedOrders"
                >
                  <v-icon color="#FFF" :small="$vuetify.breakpoint.mdAndDown" class="mr-1">mdi-check-decagram</v-icon>
                  {{$t('WpLabRequest.AiProcessing')}} ({{ vDataTable.selected.length }})
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <div class="mx-4 mb-4 fill-height mt-5" >
            <v-data-table
              v-model="vDataTable.selected"
              :headers="headersMain"
              :items="vDataTable.data"
              :search="vDataTable.search"
              fixed-header
              show-select
              :page.sync="vDataTable.options.page"
              :itemsPerPage.sync="vDataTable.options.itemsPerPage"
              :options.sync="vDataTable.options"
              :height="$vuetify.breakpoint.height - 340 - offsetAppBar"
              :footer-props="{
                itemsPerPageText: $t('itemsPerPageText'),
                itemsPerPageAllText: $t('itemsPerPageAllText'),
                showFirstLastPage: true,
                showCurrentPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
              }"
              item-key="order_skey"
              class="custom-table "
            >
              <template v-slot:[`item.date_receive`]="{ item }">
                <span>{{ formatDateTimeDisplay(item.date_receive) }}</span>
              </template>
              <template v-slot:[`item.status_result_report_pdf`]="{ item }">
                <div class="d-inline-flex align-center">
                  <!-- <v-chip
                    v-if="item.status_result_report_pdf === 'COMPLETE'"
                    color="success"
                    outlined
                    class="status-chip chip-clickable font-weight-bold"
                    @click="requestLabResultReportPdf(item.order_id, true)"
                  >
                    <v-icon left small>mdi-printer</v-icon>
                    {{ item.status_result_report_pdf }}
                  </v-chip> -->
                  <v-chip
                    v-if="item.status_result_report_pdf === 'COMPLETE'"
                    color="success"
                    outlined
                    class="status-chip-large chip-clickable font-weight-bold"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div 
                          v-bind="attrs" 
                          v-on="on" 
                          class="d-flex align-center fill-height"
                          @click="requestLabResultReportPdf(item.order_id, true)"
                        >
                          <v-icon size="24" class="mr-2">mdi-printer</v-icon>
                          {{ item.status_result_report_pdf }}
                        </div>
                      </template>
                      <span>{{$t('WpLabRequest.AIGeneratedLabReport')}}</span>
                    </v-tooltip>
                  </v-chip>

                  <v-chip
                    v-else-if="item.status_result_report_pdf === 'WAITING_AI'"
                    color="amber darken-2"
                    dark
                    outlined
                    class="status-chip-large font-weight-bold"
                  >
                    <v-icon size="24" class="animate-pulse">mdi-clock-outline</v-icon>
                    {{ item.status_result_report_pdf }}
                  </v-chip>

                  <v-chip
                    v-else-if="item.status_result_report_pdf === 'OPEN'"
                    color="blue darken-2"
                    outlined
                    class="status-chip-large font-weight-bold"
                  >
                    <v-icon size="24">mdi-folder-open-outline</v-icon>
                    {{ item.status_result_report_pdf }}
                  </v-chip>

                  <v-chip
                    v-else-if="item.status_result_report_pdf === 'PROCESSING'"
                    color="error"
                    outlined
                    class="status-chip-large font-weight-bold"
                  >
                    <v-icon size="24" class="animate-spin">mdi-cog-outline</v-icon>
                    {{ item.status_result_report_pdf }}
                  </v-chip>

                  <v-chip
                    v-else-if="item.status_result_report_pdf === 'Fail'"
                    color="error"
                    dark
                    class="status-chip-large chip-clickable font-weight-bold"
                    @click="showNotificationIssue(item.order_id)"
                  >
                    <v-icon size="24">mdi-alert-circle-outline</v-icon>
                    {{ item.status_result_report_pdf }}
                  </v-chip>

                  <v-chip
                    v-else
                    color="grey"
                    outlined
                    class="status-chip-large font-weight-bold"
                  >
                    <v-icon size="24">mdi-help-circle-outline</v-icon>
                    {{ item.status_result_report_pdf || 'UNKNOWN' }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="d-flex align-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        color="orange" 
                        size="24" 
                        class="mr-3 action-icon-btn" 
                        v-bind="attrs" 
                        v-on="on" 
                        @click="requestLabResultReportPdf(item.order_id, true)"
                      >
                        mdi-printer
                      </v-icon>
                    </template>
                    <span>{{$t('WpLabRequest.LabReport')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        :disabled="item.is_approved === 1" 
                        :color="item.is_approved === 1 ? 'grey lighten-1' : 'success'" 
                        size="24" 
                        class="action-icon-btn"
                        :class="{ 'disabled-icon': item.is_approved === 1 }"
                        v-bind="attrs" 
                        v-on="on" 
                        @click="approveOrder(item)"
                      >
                        mdi-check-decagram
                      </v-icon>
                    </template>
                    <span>{{$t('WpLabRequest.AiProcessing')}}</span>
                  </v-tooltip>
                </div>
              </template>
              
              <template v-slot:item.is_get_back="{ item }">
                <v-icon v-if="item.is_get_back === 1" large color="green">mdi-checkbox-marked-circle</v-icon>
              </template>

              <template v-slot:item.is_urgent="{ item }">
                
                <v-row dense flat justify="start" align="center" >
                  <v-col cols="9" class="d-flex justify-center align-center">
                    <div>
                      <v-icon  class="icon-noti" v-if="item.is_urgent !== null && item.is_urgent !== 0" color="red" size="30">
                        mdi-bell-ring-outline
                      </v-icon>
                      <v-icon  class="icon-noti" v-else color="#A9A9A9" size="30">
                        mdi-bell-ring-outline
                      </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:footer>
                <tr class="sticky-table-footer" style="position: absolute">
                  <td>Selected({{ vDataTable.selected.length }})s</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-container>

    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          <span class="white--text">
            {{ progressMessage }}
          </span>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.lifestyle" max-width="1100px" scrollable overlay-color="#1d2939" overlay-opacity="0.7">
      <v-card class="rounded-xl overflow-hidden">
        <v-card-title class="d-flex justify-space-between align-center py-5 px-8 white">
          <div>
            <div class="text-overline primary--text font-weight-bold mb-n1">ASSESSMENT FORM</div>
            <div class="text-h5 font-weight-black" style="color: #1d2939;">Lifestyle Questionnaire</div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-8 grey lighten-5">
          <div v-for="(section, sIdx) in questionSections" :key="sIdx" class="lifestyle-section-card">
            <div class="d-flex justify-space-between align-start mb-6">
              <div class="section-title-wrap">
                <h2 class="section-main-title">{{ section.title }}</h2>
                <p class="section-subtitle">{{ section.subtitle }}</p>
              </div>
              <div class="section-number-badge">{{ sIdx + 1 }}</div>
            </div>
            
            <div v-for="q in section.questions" :key="q.id" class="question-block">
              <div class="d-flex align-center mb-4">
                <span class="lifestyle-question-label">{{ q.desc }}</span>
                <span class="required-badge ml-3">Required</span>
              </div>
              <v-radio-group v-model="lifestyleForm[q.id]" class="mt-0 custom-radio-group" hide-details>
                <v-row dense>
                  <v-col cols="12" md="6" v-for="(opt, oIdx) in q.options" :key="oIdx">
                    <div class="radio-option-card" :class="{ 'active': lifestyleForm[q.id] === opt }">
                      <v-radio :value="opt" color="#2563eb">
                        <template v-slot:label>
                          <div class="option-label-content">
                            <div class="option-head">{{ q.desc }}</div>
                            <div class="option-tail">{{ opt }}</div>
                          </div>
                        </template>
                      </v-radio>
                    </div>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-8 white">
          <div class="caption grey--text text--darken-1 mr-6">Please review all sections before saving.</div>
          <v-spacer></v-spacer>
          <v-btn text color="#667085" class="rounded-lg px-6 font-weight-bold" @click="dialog.lifestyle = false">CANCEL</v-btn>
          <v-btn color="#2563eb" dark class="rounded-lg px-10 font-weight-bold" depressed large @click="saveLifestyleData">SAVE QUESTIONNAIRE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="notificationIssue.show" max-width="500px">
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">mdi-alert-circle-outline</v-icon>
          {{ $t('WpLabRequest.status') }}: Fail
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-if="notificationIssue.loading" class="d-flex justify-center py-6">
            <v-progress-circular indeterminate color="error"></v-progress-circular>
          </div>
          <div v-else>
            <div class="mb-2"><strong>Order ID:</strong> {{ notificationIssue.order_id }}</div>
            <div class="mb-2" v-if="notificationIssue.created_dt"><strong>Date:</strong> {{ formatDateTimeDisplay(notificationIssue.created_dt) }}</div>
            <div class="mb-1"><strong>Issue:</strong></div>
            <div style="white-space: pre-wrap;">{{ notificationIssue.issue || 'No issue detail recorded' }}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="notificationIssue.show = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import Base64Binary from 'base64-arraybuffer'
import { io } from 'socket.io-client'
export default {

  props: ['parentComponent'],

  data () {
    return {
      socket: null,
      refreshInterval: null,
      appName: process.env.VUE_APP_DB_APP_NAME,
      progressMessage: '',
      selectedItem: null,
      activeTab: 0,
      dialog: {
        dialogProgress: false,
        ogReceivedDateFromTo: false,
        lifestyle: false
      },
      notificationIssue: {
        show: false,
        loading: false,
        order_id: '',
        status: '',
        issue: '',
        created_dt: ''
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true
        },
      },
      criteria: {
        ReceivedDateFromTo: [new Date(new Date().setHours(0, 0, 0, 0) - (new Date().getTimezoneOffset() * 60000))
            .toISOString()
            .slice(0, 10)]
      },
      searchName: '',
      find_hn: '',
      order_id: '',
      dateSearchFrom: '',
      dateSearchTo: '',
      dialogpdfShow: false,
      pdfShow: '',
      isApproved: false,
      lifestyleForm: this.initLifestyleForm(),
      nutritionFields: {
        green_leafy_vegetables: { label: 'Leafy Vegetables' },
        fresh_fruit: { label: 'Fresh Fruit' },
        fried_foods: { label: 'Fried Foods' },
        sugary_drinks: { label: 'Sugary Drinks' },
        processed_foods: { label: 'Processed Foods' }
      },
      physicalQuestions: [
        { key: 'cardio', title: 'Cardio' },
        { key: 'strength_training', title: 'Strength Training' },
        { key: 'daily_activity', title: 'Daily Activity' }
      ],
      foodQuestions: [
        { key: 'green_leafy_vegetables', title: 'Green leafy vegetables and colorful vegetables' },
        { key: 'fresh_fruit', title: 'Fresh fruit (low in sugar)' },
        { key: 'fried_foods', title: 'Fried foods and high-fat foods' },
        { key: 'sugary_drinks', title: 'Sugary drinks and sweets' },
        { key: 'processed_foods', title: 'Processed and strongly flavored foods' }
      ],
      habitQuestions: [
        { key: 'water_intake', title: 'Water Intake' },
        { key: 'smoking_status', title: 'Smoking Status' },
        { key: 'alcohol_consumption', title: 'Alcohol Consumption' },
        { key: 'sleep_duration', title: 'Sleep Duration' },
        { key: 'sleep_quality', title: 'Sleep Quality' },
        { key: 'stress_level', title: 'Stress Level' },
        { key: 'screen_time', title: 'Screen Time' }
      ],
      options: {
        cardio: ['Inactive(<75mins/week)', 'Insufficiently Active(75-150mins/week)', 'Active(150-300mins/week)', 'Highly Active (>300mins/week)'],
        strength_training: ['Inactive(<75mins/week)', 'Insufficiently Active(75-150mins/week)', 'Active(150-300mins/week)', 'Highly Active (>300mins/week)'],
        daily_activity: ['Inactive(<75mins/week)', 'Insufficiently Active(75-150mins/week)', 'Active(150-300mins/week)', 'Highly Active (>300mins/week)'],
        frequency: ['Almost every day (5-7 days/week)', 'Sometimes (1-4 days/week)', 'Very rarely (1-2 times per month)'],
        water_intake: ['Low - < 1.5 liters', 'Medium - 1.5-2.5 liters', 'High - > 2.5 liters'],
        smoking_status: ['Never smoker', 'Former smoker', 'Current smoker'],
        alcohol_consumption: ['Non-drinker', 'Light (≤ 3 drinks/week)', 'Moderate (4-14 drinks/week)', 'Heavy (> 14 drinks/week)'],
        sleep_duration: ['Less than 6 hours per night', '6-7 hours per night', '7-9 hours per night', 'More than 9 hours per night'],
        sleep_quality: ['Normal quality', 'Minor problems', 'Poor quality'],
        stress_level: ['Low stress', 'Moderate stress', 'High stress'],
        screen_time: ['Less than 2 hours', '2-4 hours', 'More than 4 hours']
      },
      questionSections: [
        {
          title: 'Physical Activity',
          subtitle: 'Assess exercise habits across cardio, strength training, and daily movement.',
          questions: [
            { id: 'q000100', desc: 'Cardio', options: ['Cardio - Inactive(<75mins/week)', 'Cardio - Insufficiently Active(75-150mins/week)', 'Cardio - Active(150-300mins/week)', 'Cardio - Highly Active (>300mins/week)'] },
            { id: 'q000200', desc: 'Strength Training', options: ['Strength Training - Inactive(<75mins/week)', 'Strength Training - Insufficiently Active(75-150mins/week)', 'Strength Training - Active(150-300mins/week)', 'Strength Training - Highly Active (>300mins/week)'] },
            { id: 'q000300', desc: 'Daily Activity', options: ['Daily Activity - Inactive(<75mins/week)', 'Daily Activity - Insufficiently Active(75-150mins/week)', 'Daily Activity - Active(150-300mins/week)', 'Daily Activity - Highly Active (>300mins/week)'] }
          ]
        },
        {
          title: 'Food & Nutrition',
          subtitle: 'Understand dietary patterns and frequency of healthy and unhealthy food choices.',
          questions: [
            { id: 'q000400', desc: 'Green leafy vegetables and colorful vegetables', options: ['Almost every day (5-7 days/week)', 'Sometimes (1-4 days/week)', 'Very rarely (1-2 times per month)'] },
            { id: 'q000500', desc: 'Fresh fruit (low in sugar)', options: ['Almost every day (5-7 days/week)', 'Sometimes (1-4 days/week)', 'Very rarely (1-2 times per month)'] },
            { id: 'q000600', desc: 'Fried foods and high-fat foods', options: ['Almost every day (5-7 days/week)', 'Sometimes (1-4 days/week)', 'Very rarely (1-2 times per month)'] },
            { id: 'q000700', desc: 'Sugary drinks and sweets', options: ['Almost every day (5-7 days/week)', 'Sometimes (1-4 days/week)', 'Very rarely (1-2 times per month)'] },
            { id: 'q000800', desc: 'Processed and strongly flavored foods', options: ['Almost every day (5-7 days/week)', 'Sometimes (1-4 days/week)', 'Very rarely (1-2 times per month)'] }
          ]
        },
        {
          title: 'Habits & Wellbeing',
          subtitle: 'Additional factors affecting your long-term health and daily energy levels.',
          questions: [
            { id: 'q000900', desc: 'Water Intake', options: ['Low - Less than 6 glasses per day (< 1.5 liters)', 'Medium - About 6-10 glasses per day (1.5-2.5 liters)', 'High - More than 10 glasses per day (> 2.5 liters)'] },
            { id: 'q001000', desc: 'Smoking Status', options: ['Never smoker', 'Former smoker', 'Current smoker'] },
            { id: 'q001100', desc: 'Alcohol Consumption', options: ['Non-drinker', 'Light (≤ 3 drinks/week)', 'Moderate (4-14 drinks/week)', 'Heavy (> 14 drinks/week)'] },
            { id: 'q001200', desc: 'Sleep Duration', options: ['Less than 6 hours', '6-7 hours', '7-9 hours', 'More than 9 hours'] },
            { id: 'q001300', desc: 'Sleep Quality', options: ['Normal quality', 'Minor problems', 'Poor quality'] },
            { id: 'q001400', desc: 'Stress Level', options: ['Low stress', 'Moderate stress', 'High stress'] },
            { id: 'q001500', desc: 'Screen Time', options: ['Less than 2 hours', '2-4 hours', 'More than 4 hours'] }
          ]
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    selectDate () {
      return 'ช่วงเวลาค้นหาข้อมูล'
    },
    headersMain () {
      return [
        { text: this.$t('actions'), value: 'actions', width: '60px', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.receivedDate'), value: 'received_date', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.patientFullname'), value: 'patient_fullname', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.labNumber'), value: 'order_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.HN'), value: 'hn', align: 'left', class: 'text-xl-left body-1 black--text' },
        /* { text: this.$t('WpLabRequest.Hosital Lab No'), value: 'hosital_lab_no', align: 'center', class: 'text-xl-center body-1 black--text' }, */
        { text: this.$t('WpLabRequest.Age'), value: 'age', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.Gender'), value: 'sex_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.CollectionDate'), value: 'collection_date', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.SecondaryApprovedDate'), value: 'approve_date_2', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabRequest.status'), value: 'status_result_report_pdf', align: 'left', class: 'text-xl-left body-1 black--text' }
      ]
    },
    offsetAppBar () {
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
    dateRangeText () {
      if (this.criteria.ReceivedDateFromTo.length > 0) {
        return this.criteria.ReceivedDateFromTo.map(date => {
          const d = new Date(date)
          const day = String(d.getDate()).padStart(2, '0')
          const month = String(d.getMonth() + 1).padStart(2, '0')
          /* const year = d.getFullYear() + 543 */
          const year = d.getFullYear()
          return `${day}-${month}-${year}`
        }).join(' ~ ')
      }
      return ''
    }
  },
  async created () {
    this.retrieveLabResultReport()
    this.refreshInterval = setInterval(() => {
      this.retrieveLabResultReport('auto')
    }, 20000)
    /* this.setupSocket() */
  },
  beforeDestroy () {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
    if (this.socket) {
      this.socket.disconnect()
    }
  },

  methods: {
    setupSocket () {
      const socketUrl = 'http://localhost:5000'
      if (this.socket) {
        this.socket.disconnect()
      }
      this.socket = io(socketUrl, {
        path: '/lis-middleware-api/socket.io',
        // 1. ลองปรับให้ polling นำหน้า เพื่อให้ Threading ของ Flask สร้าง Session ให้เสร็จก่อน
        transports: ['polling'],
        upgrade: false,
        // 2. เพิ่ม Timeout ให้ยาวขึ้น เพื่อรอการประมวลผลจาก Flask Threading
        timeout: 30000,
        reconnection: true,
        addTrailingSlash: false
      })
      this.socket.on('connect', () => {
        console.log('Connected Success! ID:', this.socket.id)
      })
      this.socket.onAny((eventName, ...args) => {
        console.log(`DEBUG: Received [${eventName}]`, args)
      })
      this.socket.on('order_status_updated', (data) => {
        console.log('Real-time Update Received:', data)
        const index = this.vDataTable.data.findIndex(item => item.order_id === data.order_id)
        if (index !== -1) {
          // ใช้ Vue.set หรือเจาะจง index เพื่อให้ Reactivity ทำงาน (สำหรับ Vue 2)
          this.$set(this.vDataTable.data[index], 'status_result_report_pdf', data.status)

          // เพิ่ม Toast แจ้งเตือนเพื่อให้ User ทราบว่าข้อมูลเปลี่ยนแล้ว
          /* this.$swal({
            toast: true,
            position: 'top-end',
            type: 'success',
            title: `Order ${data.order_id}: ${data.status}`,
            showConfirmButton: false,
            timer: 2000
          }) */
        }
      })

      this.socket.on('connect_error', (err) => {
        console.error('Socket Connection Error:', err.message)
        // หากเจอ websocket error ให้ถอยกลับไปใช้ polling อย่างเดียวชั่วคราว
        if (err.message === 'websocket error') {
          this.socket.io.opts.transports = ['polling']
        }
      })
    },
    initialize () {
      this.vDataTable.selected = []
    },
    async retrieveLabResultReport (methodcode) {
      if (methodcode !== 'auto') {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
      }
      this.isAddNew = false
      if (this.criteria.ReceivedDateFromTo.length > 0) {
        this.dateSearchFrom = this.criteria.ReceivedDateFromTo[0] || ''
        this.dateSearchTo = this.criteria.ReceivedDateFromTo.length > 1
          ? this.criteria.ReceivedDateFromTo[1]
          : new Date().toISOString().slice(0, 10)
      }
      const payload = {
        patient_name: this.searchName || '',
        received_date_from: this.dateSearchFrom || null,
        received_date_to: this.dateSearchTo || null,
        hn: this.find_hn || '',
        order_id: this.order_id || '',
      }
      try {
        const url = process.env.VUE_APP_API + '/retrieveLabResultReportMSSQL'
        const headers = {
          'Content-Type': 'application/json'
        }
        const response = await this.axios.post(url, payload, { headers })
        if (response.data && response.data.isSuccess) {
          this.vDataTable.data = response.data.data || response.data.Table || []
          this.initialize()
        } else {
          const msg = (response.data && (response.data.reasonText || response.data.Message || response.data.message)) || 'No data'
          this.$swal({ type: 'error', title: msg })
        }
      } catch (e) {
        if (methodcode !== 'auto') {
          this.$swal({ type: 'error', title: e.message || 'Request failed' })
        } else {
          console.error('Auto refresh failed:', e)
        }
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async requestLabResultReportPdf (OrderId, forceRegen = false) {
      this.is_open = false
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('Now Printing waiting.......')
      const currentLang = this.$i18n.locale
      let url = `${process.env.VUE_APP_API}/getLabAiReportPDFFinal/${encodeURIComponent(OrderId)}?lang=${currentLang}`
      if (forceRegen) {
        url += '&regeneratePDF=true'
      }
      try {
        const response = await this.axios.get(url, { responseType: 'arraybuffer' })
        try {
          const text = new TextDecoder().decode(response.data)
          const json = JSON.parse(text)
          if (json && json.isSuccess === false) {
            this.$swal({ type: 'warning', title: json.Message || 'No data' })
            return
          }
        } catch (_) {}
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const urlBlob = window.URL.createObjectURL(blob)
        const newTab = window.open()
        newTab.document.write(`
          <html>
            <head><title>${OrderId}</title></head>
            <body style="margin:0">
              <iframe src="${urlBlob}" frameborder="0" style="width:100%;height:100vh;"></iframe>
            </body>
          </html>
        `)
      } catch (e) {
        if (e.response && e.response.data) {
          try {
            const text = new TextDecoder().decode(e.response.data)
            const json = JSON.parse(text)
            this.$swal({ type: 'warning', title: json.Message || json.message || e.message })
            return
          } catch (_) {}
        }
        this.$swal({ type: 'error', title: e.message || 'Request failed' })
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async showNotificationIssue (OrderId) {
      this.notificationIssue.order_id = OrderId
      this.notificationIssue.status = ''
      this.notificationIssue.issue = ''
      this.notificationIssue.created_dt = ''
      this.notificationIssue.show = true
      this.notificationIssue.loading = true
      try {
        const url = process.env.VUE_APP_API + '/retrieveLabResultNotificationIssue'
        const payload = { order_id: OrderId }
        const headers = { 'Content-Type': 'application/json' }
        const response = await this.axios.post(url, payload, { headers })
        if (response.data && response.data.isSuccess && response.data.data) {
          this.notificationIssue.status = response.data.data.status || ''
          this.notificationIssue.issue = response.data.data.issue || ''
          this.notificationIssue.created_dt = response.data.data.created_dt || ''
        } else {
          this.notificationIssue.issue = (response.data && response.data.reasonText) || 'No issue detail recorded'
        }
      } catch (e) {
        this.notificationIssue.issue = e.message || 'Request failed'
      } finally {
        this.notificationIssue.loading = false
      }
    },
    formatDateTimeDisplay (date) {
      if (!date) return ''
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      /* const year = d.getFullYear() + 543 */
      const year = d.getFullYear()
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
    },
    async approveOrder (item) {
      // ตรวจสอบความถูกต้องของข้อมูลเบื้องต้น
      if (!item || !item.order_id) {
        return
      }
      // แสดง Loading State
      this.dialog.dialogProgress = true
      this.progressMessage = 'Approving...'
      try {
        const url = `${process.env.VUE_APP_API}/approveLabResult`
        const payload = {
          order_id: item.order_id,
          approved_by: 'current_user'
        }
        // ยิง API Approve
        const response = await this.axios.post(url, payload)
        if (response.data && response.data.isSuccess) {
          /* this.$swal({
            icon: 'success',
            title: 'Approved!',
            text: 'The report has been approved successfully.',
            timer: 1500,
            showConfirmButton: false
          }) */
          this.$swal({
            type: 'success', // เปลี่ยนจาก icon เป็น type
            title: this.$t('WpLabRequest.AiProcessingTitle'),
            text: this.$t('WpLabRequest.AiProcessingText'),
            timer: 2000,
            showConfirmButton: false,
          })
          setTimeout(() => {
            this.retrieveLabResultReport()
          }, 800)
        } else {
          throw new Error(response.data.reasonText || 'Could not approve this order.')
        }
      } catch (error) {
        console.error('Approve Error:', error)
        this.$swal({
          icon: 'error',
          title: 'Action Failed',
          text: error.message || 'An unexpected error occurred.'
        })
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async approveSelectedOrders () {
      if (this.vDataTable.selected.length === 0) return
      // กรองเอาเฉพาะรายการที่ยังไม่ได้ Approved
      const pendingOrders = this.vDataTable.selected.filter(item => item.is_approved !== 1)
      if (pendingOrders.length === 0) {
        this.$swal({ type: 'info', title: 'All selected orders are already approved.' })
        return
      }
      const result = await this.$swal({
        title: 'Bulk Approve',
        text: `Are you sure you want to approve ${pendingOrders.length} orders?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve all!',
        cancelButtonText: 'Cancel'
      })
      console.log('Bulk Approve Confirmation Result:', result)
      if (result === true) {
        this.dialog.dialogProgress = true
        this.progressMessage = `Approving ${pendingOrders.length} orders...`
        try {
          // ใช้ Promise.all เพื่อยิง API พร้อมกันทุกรายการที่เลือก
          const promises = pendingOrders.map(item => {
            return this.axios.post(`${process.env.VUE_APP_API}/approveLabResult`, {
              order_id: item.order_id,
              approved_by: 'current_user'
            })
          })
          const results = await Promise.all(promises)
          // ตรวจสอบจำนวนที่สำเร็จ
          const successCount = results.filter(res => res.data && res.data.isSuccess).length
          this.$swal({
            type: 'success',
            title: 'Success!',
            text: `Successfully approved ${successCount} orders.`,
            timer: 2000
          })
          // ล้างค่าที่เลือกและดึงข้อมูลใหม่
          this.vDataTable.selected = []
          setTimeout(() => {
            this.retrieveLabResultReport()
          }, 1000)
        } catch (error) {
          console.error('Bulk Approve Error:', error)
          this.$swal({ type: 'error', title: 'Error', text: 'Some orders could not be approved.' })
        } finally {
          this.dialog.dialogProgress = false
        }
      }
    },
    initLifestyleForm () {
      return {
        q000100: null,
        q000200: null,
        q000300: null,
        q000400: null,
        q000500: null,
        q000600: null,
        q000700: null,
        q000800: null,
        q000900: null,
        q001000: null,
        q001100: null,
        q001200: null,
        q001300: null,
        q001400: null,
        q001500: null
      }
    },
    async openLifestyleDialog (item) {
      this.selectedItem = item
      // 1. Reset ฟอร์มให้เป็นค่าว่างก่อนทุกครั้ง
      this.lifestyleForm = this.initLifestyleForm()

      // 2. แสดง Loading
      this.dialog.dialogProgress = true
      this.progressMessage = 'Fetching Questionnaire Data...'

      try {
        // 3. เรียก API ไปยัง Python Backend
        const url = process.env.VUE_APP_API + '/retrieveLifestyleQuestionnaire'
        const payload = { order_id: item.order_id }
        const response = await this.axios.post(url, payload)

        if (response.data && response.data.isSuccess) {
          const fetchedData = response.data.data // ข้อมูลที่ได้จะเป็น Array ของ result_item_id และ result_value
          // 4. Mapping ข้อมูลเข้า lifestyleForm
          if (fetchedData && fetchedData.length > 0) {
            fetchedData.forEach(row => {
              // ตรวจสอบว่า result_item_id ตรงกับที่มีใน form และมีค่า value ไม่เป็น null/ว่าง
              if (Object.prototype.hasOwnProperty.call(this.lifestyleForm, row.result_item_id)) {
                // ถ้าค่าเป็น null หรือ string ว่าง ตัว v-radio จะไม่ถูกเลือกโดยอัตโนมัติ
                this.lifestyleForm[row.result_item_id] = row.result_value || null
              }
            })
          }
        } else {
          console.warn('No existing data found for this order.')
        }
        // 5. เปิด Dialog Questionnaire
        this.dialog.lifestyle = true
      } catch (e) {
        console.error('Error fetching questionnaire:', e)
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'Cannot retrieve questionnaire data.'
        })
      } finally {
        // 6. ปิด Loading
        this.dialog.dialogProgress = false
      }
    },
    async saveLifestyleData () {
      this.dialog.dialogProgress = true
      this.progressMessage = 'Saving Lifestyle...'
      try {
        const url = process.env.VUE_APP_API + '/saveLifestyleQuestionnaire'
        const payload = {
          order_id: this.selectedItem.order_id,
          lifestyle_data: this.lifestyleForm
        }
        console.log('Saving Lifestyle Data with payload:', payload)
        const response = await this.axios.post(url, payload)
        if (response.data.isSuccess) {
          this.$swal({ type: 'success', title: 'Saved!', timer: 1500, showConfirmButton: false })
          this.dialog.lifestyle = false
          this.retrieveLabResultReport()
        }
        /* const response = await this.axios.post(process.env.VUE_APP_API + '/savePatientLifestyle', payload)
        if (response.data.isSuccess) {
          this.$swal({ type: 'success', title: 'Saved!', timer: 1500, showConfirmButton: false })
          this.dialog.lifestyle = false
          this.retrieveLabResultReport()
        } */
      } catch (e) {
        this.$swal({ type: 'error', title: 'Save Failed' })
      } finally {
        this.dialog.dialogProgress = false
      }
    },
  },
}
</script>
<style scoped>
/* ส่วนของตารางหลัก */
/* .custom-table >>> th {
  background-color: #f8fbff !important;
  color: #003057 !important;
} */
 /* 1. กำหนดให้แถวตารางเป็นลูกศรปกติ */
.custom-table >>> tbody tr {
  cursor: default !important
}

/* 2. กำหนดให้รูปมือปรากฏเฉพาะที่ Icon actions */
.custom-table >>> tbody tr .v-icon {
  cursor: pointer !important
}

/* 3. กำหนดให้รูปมือปรากฏที่ Checkbox (ถ้ามี) */
.custom-table >>> tbody tr .v-simple-checkbox {
  cursor: pointer !important
}

/* 4. ส่วนของ Hover สีแถว (คงไว้แต่ไม่ต้องใส่ cursor: pointer) */
.custom-table >>> tbody tr:hover {
  background-color: #E3F2FD !important
}

/* ส่วนของ Card กลุ่มคำถาม (แก้ไขจุดที่ลืมใส่ . หน้าชื่อคลาส) */
.lifestyle-section-card {
  border: 1px solid #eef2f7;
  border-radius: 24px;
  background-color: #ffffff;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
}

.section-main-title {
  font-size: 24px;
  font-weight: 800;
  color: #1d2939;
  letter-spacing: -0.02em;
}

.section-subtitle {
  font-size: 14px;
  color: #64748b;
}

.section-number-badge {
  background: #eff6ff;
  color: #1d4ed8;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  border: 1px solid #d3e2ff;
}

/* ส่วนของ Block คำถาม */
.question-block {
  background: #f9fbff;
  border: 1px solid #e4edf7;
  border-radius: 20px;
  padding: 22px;
  margin-bottom: 20px;
}

.lifestyle-question-label {
  font-size: 17px;
  font-weight: 800;
  color: #1d2939;
}

.required-badge {
  font-size: 11px;
  font-weight: 800;
  color: #b42318;
  background: #fef3f2;
  border: 1px solid #fecdca;
  border-radius: 8px;
  padding: 2px 8px;
  text-transform: uppercase;
}

/* --- ส่วนของ Radio Option (บังคับเป็นสีดำ/เข้มทั้งหมด) --- */

.radio-option-card {
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
}

/* เมื่อเลือกแล้วให้ขอบและพื้นหลังเปลี่ยนสี แต่ตัวหนังสือยังเข้มเหมือนเดิม */
.radio-option-card.active {
  border-color: #2563eb;
  background-color: #f0f7ff;
  box-shadow: 0 0 0 1px #2563eb;
}

/* บังคับหัวข้อตัวเลือกให้เป็นสีดำเข้ม */
.option-head { 
  font-weight: 800; 
  font-size: 14px; 
  color: #1d2939 !important; /* สีดำเข้ม */
}

/* บังคับรายละเอียดตัวเลือกให้เป็นสีเทาเข้ม (เพื่อให้ยังอ่านง่ายแต่ไม่จางจนเกินไป) */
.option-tail { 
  font-size: 13px; 
  color: #475467 !important; /* สีเทาเข้ม (Slate) อ่านง่ายกว่าสีเทาอ่อน */
  line-height: 1.2; 
}

/* ปรับแต่งระยะภายใน v-radio */
.custom-radio-group >>> .v-radio {
  width: 100%;
  padding: 12px 16px;
  margin: 0 !important;
}

.custom-radio-group >>> .v-label {
  width: 100%;
  opacity: 1 !important; /* ป้องกัน Vuetify ปรับจางเอง */
}

/* จัดกึ่งกลางวงกลม Radio */
.custom-radio-group >>> .v-input--selection-controls__input {
  margin-right: 12px !important;
  align-self: center;
}

.option-label-content {
  display: flex;
  flex-direction: column;
}

.line-height-tight {
  line-height: 1.2;
}

.footer-hint {
  font-size: 13px;
}
</style>